import React from "react";

import { LoadingAnimation } from "components/ui/loading-animation";

export const PageLoadingState: React.FC = () => (
  <div
    className="fixed inset-0 z-20 flex items-center justify-center"
    data-testid="page-loading-state"
    data-launch-blocking=""
  >
    <LoadingAnimation size="lg" />
  </div>
);
